import React, { memo }  from 'react';
import IconWrapper from '../IconWrapper';

const IconCautionTriangle = (props) => (
    <IconWrapper fill={props.fill ? props.fill : "#E29907"} className={`caution-triangle ${props.className}`} viewBox="0 2 30 26">
        <path d="M15,8.1125 L24.4125,24.375 L5.5875,24.375 L15,8.1125 L15,8.1125 Z M15,3.125 L1.25,26.875 L28.75,26.875 L15,3.125 Z M16.25,20.625 L13.75,20.625 L13.75,23.125 L16.25,23.125 L16.25,20.625 Z M16.25,13.125 L13.75,13.125 L13.75,18.125 L16.25,18.125 L16.25,13.125 Z"></path>
    </IconWrapper>
);

export default memo(IconCautionTriangle);
